import * as _ from 'lodash';

import * as Actions from './variables.constants';
import ReducerCreator from '../registerReducer';
import { StoreItem } from '../Store';
import { VariableType, VariableSubType, Qualifier, Unit } from '../../models';
import { buildStoreItem, buildErrorItem } from '../storeItemBuilder';

const hasAllVariablesLoaded = (state: StoreItem<boolean>): boolean => {
    return _.every(state.dictionary, v => v);
};

// This aggregate if just to trigger the auto-detection of store update regarding variables as a whole
const reduveVariables = new ReducerCreator<boolean>()
    .register<boolean>(Actions.VARIABLES_LOADING, (state, payload) => {
        const newState = new StoreItem<boolean>();
        newState.isLoading = true;
        newState.dictionary[Actions.VARIABLES_LOAD_VARIABLETYPE] = false;
        newState.dictionary[Actions.VARIABLES_LOAD_VARIABLESUBTYPE] = false;
        newState.dictionary[Actions.VARIABLES_LOAD_QUALIFIER] = false;
        newState.dictionary[Actions.VARIABLES_LOAD_UNIT] = false;
        return newState;
    })
    .register<boolean>(Actions.VARIABLES_LOAD_VARIABLETYPE, (state, types) => {
        return copyPartialStoreItem(state, Actions.VARIABLES_LOAD_VARIABLETYPE);
    })
    .register<boolean>(Actions.VARIABLES_LOAD_VARIABLESUBTYPE, (state, types) => {
        return copyPartialStoreItem(state, Actions.VARIABLES_LOAD_VARIABLESUBTYPE);
    })
    .register<boolean>(Actions.VARIABLES_LOAD_QUALIFIER, (state, types) => {
        return copyPartialStoreItem(state, Actions.VARIABLES_LOAD_QUALIFIER);
    })
    .register<boolean>(Actions.VARIABLES_LOAD_UNIT, (state, types) => {
        return copyPartialStoreItem(state, Actions.VARIABLES_LOAD_UNIT);
    })
    .register<any>(Actions.VARIABLES_LOAD_ERROR, (state, reason) => {
        const newState = new StoreItem<boolean>();
        newState.isLoading = false;
        newState.isLoaded = true;
        newState.hasError = true;
        newState.error = reason.data.Message || reason.message;
        return newState;
    });

const copyPartialStoreItem = (state: StoreItem<boolean>, action: string): StoreItem<boolean> => {
    const newState: StoreItem<boolean> = (Object as any).assign({}, state);
    newState.dictionary[action] = true;
    const isLoading = !hasAllVariablesLoaded(state);
    newState.isLoaded = !isLoading;
    newState.isLoading = isLoading;
    return newState;
};

const reduceVariableType = new ReducerCreator<VariableType>()
    .register<VariableType[]>(Actions.VARIABLES_LOAD_VARIABLETYPE, (state, types) => {
        return buildStoreItem(types);
    })
    .register<any>(Actions.VARIABLES_LOAD_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    });

const reduceVariableSubType = new ReducerCreator<VariableSubType>()
    .register<VariableSubType[]>(Actions.VARIABLES_LOAD_VARIABLESUBTYPE, (state, subTypes) => {
        return buildStoreItem(subTypes);
    })
    .register<any>(Actions.VARIABLES_LOAD_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    });

const reduceQualifier = new ReducerCreator<Qualifier>()
    .register<Qualifier[]>(Actions.VARIABLES_LOAD_QUALIFIER, (state, qualifiers) => {
        return buildStoreItem(qualifiers);
    })
    .register<any>(Actions.VARIABLES_LOAD_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    });

const reduceUnit = new ReducerCreator<Unit>()
    .register<Unit[]>(Actions.VARIABLES_LOAD_UNIT, (state, units) => {
        return buildStoreItem(units);
    })
    .register<any>(Actions.VARIABLES_LOAD_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    });
    
export function variablesTypesReducer(
    state: StoreItem<VariableType> = new StoreItem<VariableType>(),
    action: { type: string, payload: any }
): StoreItem<VariableType> {
    return reduceVariableType.reduce(state, action);
}

export function variableSubTypesReducer(
    state: StoreItem<VariableSubType> = new StoreItem<VariableSubType>(),
    action: { type: string, payload: any }
): StoreItem<VariableSubType> {
    return reduceVariableSubType.reduce(state, action);
}

export function qualifiersReducer(
    state: StoreItem<Qualifier> = new StoreItem<Qualifier>(),
    action: { type: string, payload: any }
): StoreItem<Qualifier> {
    return reduceQualifier.reduce(state, action);
}

export function unitsReducer(
    state: StoreItem<Unit> = new StoreItem<Unit>(),
    action: { type: string, payload: any }
): StoreItem<Unit> {
    return reduceUnit.reduce(state, action);
}

export function variablesReducer(
    state: StoreItem<boolean> = new StoreItem<boolean>(),
    action: { type: string, payload: any }
): StoreItem<boolean> {
    return reduveVariables.reduce(state, action);
}